import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { Page } from "modules/layout/Page";
import { useAuthDataContext, Permissions } from "modules/auth";
import { useEventData } from "modules/events";
import { Heading2 } from "components/Heading2";
import { useLiveData } from "hooks";
import { FirebaseShard } from "firebaseWrapper";

import { EventList } from "../events/components/EventList";

import { useSiteDataByUnit } from "./useSiteData";
import { AggregatedDeviceStatsRow } from "./components/AggregatedDeviceStats";
import { AggregatedDeviceStatus } from "./components/AggregatedDeviceStatus";

interface VersionData {
  mc_software_version: string;
  gsc_software_version: string;
}

export const DeviceDashboard = ({ getNow = () => Date.now() }) => {
  const { siteId, unitId, deviceId } = useParams();
  const { latestDataByUnit } = useSiteDataByUnit(siteId);
  const { eventData, isLoading: isEventDataLoading } = useEventData(
    siteId,
    unitId,
    deviceId,
    3
  );
  const { enforcer } = useAuthDataContext();
  const [latestVersionData, setLatestVersionData] = useState<VersionData[]>([]);

  useLiveData(
    {
      maxDataPoints: 1,
      firebaseShard: FirebaseShard.Tracing,
      firebaseRef: `devices/dataBySite/${siteId}/historyByDevice/${unitId}/${deviceId}/data/version_data`,
      orderByDescending: true,
      onInitialData: setLatestVersionData,
      onIncrementalData: setLatestVersionData,
    },
    [deviceId]
  );

  const deviceData = latestDataByUnit[unitId]?.[deviceId];
  const versionData = latestVersionData[0];

  return (
    <Page
      titleSupplement={
        <AggregatedDeviceStatus
          deviceData={deviceData ? [deviceData] : []}
          devices={[{ deviceId, unitId, siteId }]}
          getNow={getNow}
        />
      }
    >
      <div className="mb-6">
        <Heading2>Device Summary</Heading2>
        <AggregatedDeviceStatsRow
          deviceData={deviceData ? [deviceData] : []}
          getNow={getNow}
        />
      </div>
      <div className="mb-6">
        <Heading2>Version</Heading2>
        <p>{versionData && "CRV001 " + versionData.mc_software_version}</p>
        {/* <p><b>Safety Controller:</b> {versionData && versionData.gsc_software_version}</p> */}
      </div>
      <div className="mb-6">
        {enforcer.can(Permissions.Devices_ViewEvents) && (
          <>
            <Heading2>Events</Heading2>
            <EventList
              eventData={eventData}
              isLoading={isEventDataLoading}
              linkMoreTo={`/sites/${siteId}/units/${unitId}/events`}
            />
          </>
        )}
      </div>
    </Page>
  );
};
